const PricesTab = () => {
  return <div>Prices</div>;
};

export default PricesTab;
